import { Datagrid, EditButton, List, TextField, TextInput } from "react-admin";

const mappingFilters = [
  <TextInput key={1} label="SQR Make" source="sqrMake" alwaysOn />,
  <TextInput key={2} label="SQR Model" source="sqrModel" alwaysOn />,
  <TextInput key={3} label="Pull-A-Part Make" source="papMake" />,
  <TextInput key={4} label="Pull-A-Part Model" source="papModel" />,
];

const ListPullApartMappings = (props) => {
  return (
    <List {...props} title="Pull-A-Part Mappings" filters={mappingFilters}>
      <Datagrid>
        <TextField label="SQR Make" source="sqrMake" />
        <TextField label="SQR Model" source="sqrModel" />
        <TextField label="Pull-A-Part Make" source="papMake" />
        <TextField label="Pull-A-Part Model" source="papModel" />
        <EditButton {...props} />
      </Datagrid>
    </List>
  );
};

export default ListPullApartMappings;
